import { cn } from '@/lib/utils';
function CircularProgress({ className }: { className?: string }) {
  return (
    <div className='flex items-center justify-center'>
      <div
        className={cn(
          'h-12 w-12 bg-surface-muted rounded-full animate-pulse',
          className
        )}
      >
        <span className='sr-only'>Loading...</span>
      </div>
    </div>
  );
}

export default CircularProgress;
